import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setIsProductTourFinished } from 'store/global/globalSlice';
import DefaultSettings from 'components/DefaultSettings';
import JobGenerator from 'components/JobGenerator';
import ProductTour from 'pages/productTour';
import { getOutputLanguages, getTargetCountries } from 'api/queries/languages';
import News from 'components/News';
import { useROneFlagInitializer } from 'hooks/useROneFlagInitializer';
import PrivacyPolicyModal from 'components/Modals/PrivacyPolicyModal';

const DefaultScreen = () => {
    const { userSettings } = useAppSelector((state) => state.auth);
    const { isProductTourFinished } = useAppSelector((state) => state.global);
    const dispatch = useAppDispatch();
    useROneFlagInitializer();

    useEffect(() => {
        dispatch(setIsProductTourFinished(!!userSettings));
        getOutputLanguages(dispatch);
        getTargetCountries(dispatch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return userSettings && isProductTourFinished ? (
        <>
            <JobGenerator />
            <News />
            <PrivacyPolicyModal />
        </>
    ) : isProductTourFinished ? (
        <DefaultSettings />
    ) : (
        <ProductTour />
    );
};

export default DefaultScreen;
